module.exports = __webpack_public_path__ + "media/images/search-d669d47a8874a0c5899ae4785e7def7f.svg";